export default {
  header: {
    appName: 'Ahora Patagonia',
    toggleMenu: 'Menú',
    notifications: 'Notificaciones',
    help: 'Ayuda',
    userMenu: 'Cuenta',
    menuProfile: 'Mi perfil',
    menuLogout: 'Cerrar sesión',
  },
  footer: {
    version: 'v{{version}} · © {{year}} Ahora Patagonia',
  },
  sections: {
    general: 'General',
  },
} as const;
